import Modal from '@/common/components/Modal'
import { formatCurrency } from '@/common/utils/formatters'
import { PaymentAdvanceEstimateData } from '@/features/paymentAdvances/types/paymentAdvanceEstimate.type'

interface CreatePaymentAdvanceModalProps {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  estimateData?: PaymentAdvanceEstimateData
  dateToBePaid?: string
  confirmCreatePaymentAdvance: () => void
  createPaymentAdvanceIsPending: boolean
}

export const CreatePaymentAdvanceModal = ({
  isOpen,
  setIsOpen,
  estimateData,
  dateToBePaid,
  confirmCreatePaymentAdvance,
  createPaymentAdvanceIsPending,
}: CreatePaymentAdvanceModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      useCancellableFooter
      title="Você tem certeza?"
      titleClass="text-2xl font-bold mb-2"
      subtitle="Analise os valores do adiantamento e confirme a solicitação."
      confirmButtonClassName="bg-primary-blue"
      cancelButtonClassName="bg-white-100"
      onConfirm={() => confirmCreatePaymentAdvance()}
      disabled={createPaymentAdvanceIsPending}
      confirmButtonIsLoading={createPaymentAdvanceIsPending}
      body={
        <div className="space-y-4 text-white-800">
          <div className="text-valid">
            <p className="text-sm font-light italic">Valor a receber antecipado</p>

            <p className="text-lg font-bold">{formatCurrency(Number(estimateData?.total_that_will_be_paid ?? 0))}</p>
          </div>

          <div>
            <p className="text-sm font-light italic">Data para recebimento da antecipação</p>

            <p className="text-lg font-bold">{dateToBePaid}</p>
          </div>

          <div className="text-yellow-400">
            <p className="text-sm font-light italic">Valor a pagar de Juros</p>

            <p className="text-lg font-bold">{formatCurrency(Number(estimateData?.interest_total ?? 0))}</p>
          </div>

          <div className="text-danger-soft">
            <p className="text-sm font-light italic">Total a ser abatido da fatura após antecipação</p>

            <p className="text-lg font-bold">{formatCurrency(Number(estimateData?.discounted_from_bill ?? 0))}</p>
          </div>

          <div>
            <p className="text-sm font-light italic">Saldo da fatura após antecipação</p>

            <p className="text-lg font-bold">{formatCurrency(Number(estimateData?.bill_balance_after_advance))}</p>
          </div>
        </div>
      }
    />
  )
}
